import { render, staticRenderFns } from "./galleryBanner.vue?vue&type=template&id=53c51ddf&scoped=true&"
import script from "./galleryBanner.vue?vue&type=script&lang=js&"
export * from "./galleryBanner.vue?vue&type=script&lang=js&"
import style0 from "./galleryBanner.vue?vue&type=style&index=0&id=53c51ddf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c51ddf",
  null
  
)

export default component.exports